import { withLimitedAccess } from 'src/hoc/withLimitedAccess';

import { PropertySettingsPageV2Inner } from './PropertySettingsPageV2Inner';

import './PropertySettingsPage.scss';

export const PropertySettingsPageV2 = withLimitedAccess(PropertySettingsPageV2Inner);
